<template>
  <div class="_1200 performance" :style="'color:'+landingPage.textColor">
    <h2 class="sec-head bodyFont">{{value.title}}</h2>
    <div class="running-text" v-html="value.description"></div>
  </div>
</template>

<script>
export default {
  name: "Big-Text",
  props: {
    value: Object,
    landingPage: Object
  }};
</script>

<style scoped>
.running-text {
    font-size: 20px;
    line-height: 1.6;
    color: rgb(48, 48, 48);
    margin-bottom: 30px;
}
</style>